import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { FormLayoutDemoComponent } from './demo/view/formlayoutdemo.component';
import { FloatLabelDemoComponent } from './demo/view/floatlabeldemo.component';
import { InvalidStateDemoComponent } from './demo/view/invalidstatedemo.component';
import { DashboardDemoComponent } from './demo/view/dashboarddemo.component';
import { InputDemoComponent } from './demo/view/inputdemo.component';
import { TableDemoComponent } from './demo/view/tabledemo.component';
import { ListDemoComponent } from './demo/view/listdemo.component';
import { TreeDemoComponent } from './demo/view/treedemo.component';
import { ButtonDemoComponent } from './demo/view/buttondemo.component';
import { PanelsDemoComponent } from './demo/view/panelsdemo.component';
import { OverlaysDemoComponent } from './demo/view/overlaysdemo.component';
import { MediaDemoComponent } from './demo/view/mediademo.component';
import { MenusDemoComponent } from './demo/view/menusdemo.component';
import { MessagesDemoComponent } from './demo/view/messagesdemo.component';
import { MiscDemoComponent } from './demo/view/miscdemo.component';
import { EmptyDemoComponent } from './demo/view/emptydemo.component';
import { ChartsDemoComponent } from './demo/view/chartsdemo.component';
import { FileDemoComponent } from './demo/view/filedemo.component';
import { DocumentationComponent } from './demo/view/documentation.component';
import { DisplayComponent } from './utilities/display.component';
import { ElevationComponent } from './utilities/elevation.component';
import { FlexboxComponent } from './utilities/flexbox.component';
import { GridComponent } from './utilities/grid.component';
import { IconsComponent } from './utilities/icons.component';
import { WidgetsComponent } from './utilities/widgets.component';
import { SpacingComponent } from './utilities/spacing.component';
import { TypographyComponent } from './utilities/typography.component';
import { TextComponent } from './utilities/text.component';

import { AppCrudComponent } from './pages/app.crud.component';
import { AppCalendarComponent } from './pages/app.calendar.component';
import { AppTimelineDemoComponent } from './pages/app.timelinedemo.component';
import { AppMainComponent } from './app.main.component';
import { AppNotfoundComponent } from './pages/app.notfound.component';
import { AppErrorComponent } from './pages/app.error.component';
import { AppAccessdeniedComponent } from './pages/app.accessdenied.component';
import { AppLoginComponent } from './pages/app.login.component';
import { LoginComponent } from './login/login.component';
import { AuthenticationGuard } from './core/guards/authentication.guard';
import { AuthorizationGuard } from './core/guards/authorization.guard';

import { UsuarioListComponent } from './sigeve/usuario/usuario-list/usuario-list.component';
import { PedidoListComponent } from './sigeve/pedido/pedido-list/pedido-list.component';
import { PedidoListFinalizadoComponent } from './sigeve/pedido/pedido-list-finalizado/pedido-list-finalizado.component';
import { PedidoDetalheComponent } from './sigeve/pedido/pedido-detalhe/pedido-detalhe.component';
import { DescontoComponent } from './sigeve/desconto/desconto/desconto.component';
import { GrupoDescontoComponent } from './sigeve/desconto/grupo-desconto/grupo-desconto.component';
import { PedidoPdfComponent } from './sigeve/pedido/pedido-pdf/pedido-pdf.component';
import { PedidoDetalheResolver } from './sigeve/pedido/pedido-detalhe/pedido-detalhe.resolver';
import { PedidoPdfResolver } from './sigeve/pedido/pedido-pdf/pedido-pdf.resolver';
import { CidadeListComponent } from './sigeve/cidade/cidade-list/cidade-list.component';
import { PedidoStatusFluxoComponent } from './sigeve/pedido/pedido-status-fluxo/pedido-status-fluxo.component';
import { ProdutoListComponent } from './sigeve/produto/produto-list/produto-list.component';
import { ProdutoEstoqueListComponent } from './sigeve/produto/produto-estoque-list/produto-estoque-list.component';
import { ComissaoComponent } from './sigeve/comissao/comissao/comissao.component';
import { GrupoComissaoComponent } from './sigeve/comissao/grupo-comissao/grupo-comissao.component';
import { TipoComissaoComponent } from './sigeve/comissao/tipo-comissao/tipo-comissao.component';
import { ComissaoListComponent } from './sigeve/comissao/comissao-list/comissao-list.component';
import { ComissaoListPdfComponent } from './sigeve/comissao/comissao-list-pdf/comissao-list-pdf.component';
import { FornecedorListComponent } from './sigeve/fornecedor/fornecedor-list/fornecedor-list.component';
import { EventoListComponent } from './sigeve/evento/evento-list/evento-list.component';
import { EventoDetalheComponent } from './sigeve/evento/evento-detalhe/evento-detalhe.component';
import { EventoDetalheResolver } from './sigeve/evento/evento-detalhe/evento-detalhe.resolver';
import { EventoPedidoListComponent } from './sigeve/evento/evento-pedido-list/evento-pedido-list.component';
import { EventoPedidoDetailComponent } from './sigeve/evento/evento-pedido-detail/evento-pedido-detail.component';
import { EventoPedidoDetalheComponent } from './sigeve/evento/evento-pedido-detalhe/evento-pedido-detalhe.component';
import { EventoPedidoDetalheResolver } from './sigeve/evento/evento-pedido-detalhe/pedido-detalhe.resolver';
import { EventoPedidoPdfComponent } from './sigeve/evento/evento-pedido-pdf/evento-pedido-pdf.component';
import { EventoPedidoPdfResolver } from './sigeve/evento/evento-pedido-pdf/pedido-pdf.resolver';
import { EsqueciSenhaComponent } from './sigeve/usuario/esqueci-senha/esqueci-senha.component';
import { EventoProdutoImportarComponent } from './sigeve/evento/evento-produto-importar/evento-produto-importar.component';
import { EventoProdutoImportarLogComponent } from './sigeve/evento/evento-produto-importar-log/evento-produto-importar-log.component';

import { HomeComponent } from './sigeve/home/home.component';
import { DashboardEventoVendasComponent } from './sigeve/dashboard/dashboard-evento-vendas/dashboard-evento-vendas.component';
import { DashboardEventoVendasDetalheComponent } from './sigeve/dashboard/dashboard-evento-vendas-detalhe/dashboard-evento-vendas-detalhe.component';
import { PedidoDetalheGuidResolver } from './sigeve/pedido/pedido-detalhe/pedido-detalhe-guid.resolver';
import { AtributoComponent } from './sigeve/pessoa/atributo/atributo.component';
import { PagamentoRegraComponent } from './sigeve/pagamento/pagamento-regra/pagamento-regra.component';
import { InventarioListComponent } from './inventario/inventario-list/inventario-list.component';
import { EtapaListComponent } from './inventario/etapa-list/etapa-list.component';
import { EtapaResolver } from './inventario/etapa.resolver';
import { EtapaEstruturaResolver } from './inventario/etapa-estrutura.resolver';
import { EtapasResolver } from './inventario/etapas.resolver';
import { InventarioProdutoImport } from './inventario/models/inventario';
import { ContagemAdicionarComponent } from './inventario/contagem-adicionar/contagem-adicionar.component';
import { PrecificacaoCriarComponent } from './precificacao/precificacao-criar/precificacao-criar.component';
import { PrecificacaoAnaliseComponent } from './precificacao/precificacao-analise/precificacao-analise.component';
import { ParametrizacaoComponent } from './sigeve/parametrizacao/parametrizacao/parametrizacao.component';

@NgModule({
    imports: [
        RouterModule.forRoot([
            {
                path: '', component: AppMainComponent, canActivate: [AuthenticationGuard],
                children: [

                    {path: 'dashboard', component: DashboardDemoComponent, canActivate: [AuthorizationGuard], data:{roles:['P_ADMIN','P_SUPER_ADMIN']} },
                    {path: 'uikit/formlayout', component: FormLayoutDemoComponent},
                    {path: 'uikit/floatlabel', component: FloatLabelDemoComponent},
                    {path: 'uikit/invalidstate', component: InvalidStateDemoComponent},
                    {path: 'uikit/input', component: InputDemoComponent},
                    {path: 'uikit/button', component: ButtonDemoComponent},
                    {path: 'uikit/table', component: TableDemoComponent},
                    {path: 'uikit/list', component: ListDemoComponent},
                    {path: 'uikit/tree', component: TreeDemoComponent},
                    {path: 'uikit/panel', component: PanelsDemoComponent},
                    {path: 'uikit/overlay', component: OverlaysDemoComponent},
                    {path: 'uikit/media', component: MediaDemoComponent},
                    {path: 'uikit/menu', component: MenusDemoComponent},
                    {path: 'uikit/message', component: MessagesDemoComponent},
                    {path: 'uikit/misc', component: MiscDemoComponent},
                    {path: 'uikit/charts', component: ChartsDemoComponent},
                    {path: 'uikit/file', component: FileDemoComponent},
                    {path: 'utilities/display', component: DisplayComponent},
                    {path: 'utilities/elevation', component: ElevationComponent},
                    {path: 'utilities/flexbox', component: FlexboxComponent},
                    {path: 'utilities/grid', component: GridComponent},
                    {path: 'utilities/icons', component: IconsComponent},
                    {path: 'utilities/widgets', component: WidgetsComponent},
                    {path: 'utilities/spacing', component: SpacingComponent},
                    {path: 'utilities/typography', component: TypographyComponent},
                    {path: 'utilities/text', component: TextComponent},
                    {path: 'pages/crud', component: AppCrudComponent},
                    {path: 'pages/calendar', component: AppCalendarComponent},
                    {path: 'pages/timeline', component: AppTimelineDemoComponent},
                    {path: 'pages/empty', component: EmptyDemoComponent, canActivate: [AuthorizationGuard], data:{roles:['P_ADMIN','P_SUPER_ADMIN', 'P_VENDEDOR','P_VENDEDOR_INTERNO','P_FABRICA']} },                    
                    {path: 'documentation', component: DocumentationComponent},


                    { path: 'alterar-senha', component: EsqueciSenhaComponent, canActivate: [AuthenticationGuard] },
                    
  
                    {path: '', component: HomeComponent, canActivate: [AuthorizationGuard], data:{roles:['P_ADMIN','P_SUPER_ADMIN', 'P_VENDEDOR','P_VENDEDOR_INTERNO','P_FABRICA','P_INVENTARIO','P_PRECIFICACAO']}  },   
                    {path: 'pedidos', component: PedidoListComponent, canActivate: [AuthorizationGuard], data:{roles:['P_ADMIN','P_SUPER_ADMIN','P_FABRICA'] }},     

                           
                    {path: 'cidade-list', component: CidadeListComponent,  canActivate: [AuthorizationGuard], data:{roles:['P_ADMIN','P_SUPER_ADMIN']}},
                    {path: 'comissao', component: ComissaoComponent,  canActivate: [AuthorizationGuard], data:{roles:['P_ADMIN','P_SUPER_ADMIN','P_FABRICA']}},
                    {path: 'comissao-list', component: ComissaoListComponent },
                    {path: 'comissao-list-pdf/:idUsuario', component: ComissaoListPdfComponent,  canActivate: [AuthorizationGuard], data:{roles:['P_ADMIN','P_SUPER_ADMIN','P_FABRICA']}},                    
                    {path: 'comissao-list-pdf/:idUsuario/:dtInicio/:dtFim', component: ComissaoListPdfComponent,  canActivate: [AuthorizationGuard], data:{roles:['P_ADMIN','P_SUPER_ADMIN','P_FABRICA']}},                                        
                    {path: 'dashboard-evento-vendas/:idEvento', component: DashboardEventoVendasComponent,  canActivate: [AuthorizationGuard], data:{roles:['P_ADMIN','P_SUPER_ADMIN']}},                                        
                    {path: 'dashboard-evento-vendas-detalhe/:idEvento', component: DashboardEventoVendasDetalheComponent,  canActivate: [AuthorizationGuard], data:{roles:['P_ADMIN','P_SUPER_ADMIN']}},                                        
                    { path: 'importar-produtos/:idEvento/:descricao', component: EventoProdutoImportarComponent, canActivate: [AuthorizationGuard], data: { roles: ['P_ADMIN','P_SUPER_ADMIN'] } },
                    { path: 'evento-produto-importar-log', component: EventoProdutoImportarLogComponent, canActivate: [AuthorizationGuard], data: { roles: ['P_ADMIN','P_SUPER_ADMIN'] } },

                    {path: 'desconto', component: DescontoComponent,  canActivate: [AuthorizationGuard], data:{roles:['P_ADMIN','P_SUPER_ADMIN']}},
                    {path: 'parametrizacao', component: ParametrizacaoComponent,  canActivate: [AuthorizationGuard], data:{roles:['P_ADMIN','P_SUPER_ADMIN']}},
                    {path: 'importar-produtos/:idEvento', 
                    component: EventoProdutoImportarComponent,
                    resolve: {
                        Evento: EventoDetalheResolver
                    },
                    canActivate: [AuthorizationGuard], 
                    data:{roles:['P_ADMIN','P_SUPER_ADMIN']}
                    },

                    
                    {path: 'evento-detalhe/:idEvento', 
                            component: EventoDetalheComponent,
                            resolve: {
                                Evento: EventoDetalheResolver
                            },
                            canActivate: [AuthorizationGuard], 
                            data:{roles:['P_ADMIN','P_SUPER_ADMIN']}
                    },
                    {path: 'evento-list', component: EventoListComponent,  canActivate: [AuthorizationGuard], data:{roles:['P_ADMIN','P_SUPER_ADMIN']}},
                    {path: 'evento/:idEvento/pedido-list', component: EventoPedidoListComponent,  canActivate: [AuthorizationGuard], data:{roles:['P_ADMIN','P_SUPER_ADMIN', 'P_VENDEDOR','P_VENDEDOR_INTERNO','P_FABRICA']}},
                    {path: 'evento/:idEvento/pedido', component: EventoPedidoDetailComponent, resolve: {
                        Evento: EventoDetalheResolver
                    }, canActivate: [AuthorizationGuard], data:{roles:['P_ADMIN','P_SUPER_ADMIN', 'P_VENDEDOR','P_VENDEDOR_INTERNO','P_FABRICA']}},
                    
                    {    path: 'evento/pedido/:id', 
                            component: EventoPedidoDetalheComponent,
                            resolve: {
                                Pedido: EventoPedidoDetalheResolver
                            }

                    },
                    {
                        path: 'evento-pedido-pdf/:id',
                        component: EventoPedidoPdfComponent,
                        resolve: {
                            PedidoPdf: EventoPedidoPdfResolver
                        }
                    },
                    {
                        path: 'evento-pedido-pdf-auto/:id',
                        component: EventoPedidoPdfComponent,
                        resolve: {
                            PedidoPdf: EventoPedidoPdfResolver
                        }
                    },
                    {path: 'pagamento-regra', component: PagamentoRegraComponent,  canActivate: [AuthorizationGuard], data:{roles:['P_ADMIN','P_SUPER_ADMIN']}},
                    {path: 'atributos', component: AtributoComponent,  canActivate: [AuthorizationGuard], data:{roles:['P_ADMIN','P_SUPER_ADMIN']}},
                    {path: 'fornecedor-list', component: FornecedorListComponent,  canActivate: [AuthorizationGuard], data:{roles:['P_ADMIN','P_SUPER_ADMIN']}},
                    {path: 'grupo-comissao', component: GrupoComissaoComponent,  canActivate: [AuthorizationGuard], data:{roles:['P_ADMIN','P_SUPER_ADMIN']} },
                    {path: 'grupo-desconto', component: GrupoDescontoComponent,  canActivate: [AuthorizationGuard], data:{roles:['P_ADMIN','P_SUPER_ADMIN']} },                    
                    {path: 'pedidofechado', component: PedidoListFinalizadoComponent },
                    {    path: 'pedido/:id', 
                            component: PedidoDetalheComponent,
                            resolve: {
                                Pedido: PedidoDetalheResolver
                            }

                    },
                    {
                        path: 'pedidoguid/:id',
                        component: PedidoDetalheComponent,
                        resolve: {
                            Pedido: PedidoDetalheGuidResolver
                        }

                    },
                    {path: 'produto-list', component: ProdutoListComponent,  canActivate: [AuthorizationGuard], data:{roles:['P_ADMIN','P_SUPER_ADMIN']}},                                        
                    {path: 'produto-estoque-list', component: ProdutoEstoqueListComponent,  canActivate: [AuthorizationGuard], data:{roles:['P_ADMIN','P_SUPER_ADMIN','P_ESTOQUE']}},                                        
                    {    path: 'pedido-pdf/:id', 
                            component: PedidoPdfComponent,
                             resolve: { 
                                 PedidoPdf: PedidoPdfResolver
                            } 
                    },
                    {path: 'statusfluxo', component: PedidoStatusFluxoComponent, canActivate: [AuthorizationGuard], data:{roles:['P_ADMIN','P_SUPER_ADMIN']}},                    
                    {path: 'tipo-comissao', component: TipoComissaoComponent,  canActivate: [AuthorizationGuard], data:{roles:['P_ADMIN','P_SUPER_ADMIN']} },
                    {path: 'usuario', component: UsuarioListComponent,  canActivate: [AuthorizationGuard], data:{roles:['P_ADMIN','P_SUPER_ADMIN']} },
                    {path: 'inventario', component: InventarioListComponent,  canActivate: [AuthorizationGuard], data:{roles:['P_ADMIN','P_SUPER_ADMIN','P_INVENTARIO']}},
                    {path: 'inventario/:idInventario/etapa', component: EtapaListComponent,  canActivate: [AuthorizationGuard], data:{roles:['P_ADMIN','P_SUPER_ADMIN','P_INVENTARIO']}, resolve: {
                        etapas: EtapasResolver
                    }},
                    {path: 'inventario/:idInventario/etapa/:idEtapa', component: EtapaListComponent,  canActivate: [AuthorizationGuard], data:{roles:['P_ADMIN','P_SUPER_ADMIN','P_INVENTARIO']}, resolve: {
                        etapa: EtapaResolver, etapaEstrutura: EtapaEstruturaResolver
                    }},
                   {path: 'inventario/:idInventario/etapa/:idEtapa/importar', 
                   
                    component: ContagemAdicionarComponent,
                    canActivate: [AuthorizationGuard], data:{roles:['P_ADMIN','P_SUPER_ADMIN','P_INVENTARIO']}
                    },

                    {path: 'precificacao-criar', component: PrecificacaoCriarComponent},
                    {path: 'precificacao-analisar', component: PrecificacaoAnaliseComponent},
                ]
            },
            {
                path: '', component: AppMainComponent,
                children: [
                    { path: 'esqueci-senha/:token', component: EsqueciSenhaComponent },
                ]
            },

            { path: 'error', component: AppErrorComponent },
            { path: 'accessdenied', component: AppAccessdeniedComponent },
            { path: '404', component: AppNotfoundComponent },
            //{path: 'login', component: AppLoginComponent},
            {
                path: 'login',
                loadChildren: './login/login.module#LoginModule'
            },

            { path: '**', redirectTo: '/404' },
        ], { scrollPositionRestoration: 'enabled' })
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
